import {
  LOAD_ORDERS_REQUEST,
  LOAD_ORDERS_SUCCESS,
  LOAD_ORDERS_ERROR,
} from "../actions/types";
import initialState from "../store/initial-state";

// eslint-disable-next-line default-param-last
const orders = (state = initialState.orders, action) => {
  switch (action.type) {
    case LOAD_ORDERS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        isFetching: false,
      };
    case LOAD_ORDERS_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case LOAD_ORDERS_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
};

export default orders;
